import React, { memo } from 'react';
const row1 = ['Slack', 'Notion', 'GitHub', 'Linear', 'Google Drive', 'Zendesk', 'Jira', 'Figma', 'Discord'];
const row2 = ['Gmail', 'Intercom', 'Salesforce', 'HubSpot', 'Zoom', 'Confluence', 'Asana', 'Trello', 'Miro'];
export function Integrations() {
  return <section className="py-24 overflow-hidden border-t border-cozy-border bg-white" data-id="element-146">
      <div className="text-center mb-12 px-6" data-id="element-147">
        <h2 className="font-serif text-3xl text-cozy-text mb-4" data-id="element-148">
          Connects to everything you use.
        </h2>
        <p className="text-cozy-muted" data-id="element-149">
          Zero configuration required. Just authenticate and GetCozy starts
          building memory.
        </p>
      </div>

      <div className="relative flex flex-col gap-4" data-id="element-150">
        {/* Left fade gradient */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-151" />
        {/* Right fade gradient */}
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-152" />

        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]" data-id="element-153">
          {[...row1, ...row1, ...row1].map((item, i) => <div key={i} className="mx-3 px-6 py-3 rounded-full border border-cozy-border bg-cozy-bg text-sm font-medium text-cozy-text whitespace-nowrap shadow-sm" data-id="element-154">
              {item}
            </div>)}
        </div>

        <div className="flex w-max animate-marquee-reverse hover:[animation-play-state:paused]" data-id="element-155">
          {[...row2, ...row2, ...row2].map((item, i) => <div key={i} className="mx-3 px-6 py-3 rounded-full border border-cozy-border bg-cozy-bg text-sm font-medium text-cozy-text whitespace-nowrap shadow-sm" data-id="element-156">
              {item}
            </div>)}
        </div>
      </div>
    </section>;
}